module.exports = __webpack_public_path__ + "static/media/arrow-up-right-black.33084271.svg";